import styled from 'styled-components'

export const Container = styled.div`
    display: flex;
    gap: 0.75rem;
    align-items: center;
`
